(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["TEMP_account-profile"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript.closest('.shopify-section');
    if (!section) return;

    const countrySelect = section.querySelector('#AddressCountry');
    const provinceSelect = section.querySelector('#AddressProvince');

    if (!countrySelect || !provinceSelect) return;

    const updateProvinces = () => {
      const selectedOption = countrySelect.options[countrySelect.selectedIndex];
      const provincesData = selectedOption?.getAttribute('data-provinces');

      provinceSelect.innerHTML = '';

      if (!provincesData) {
        provinceSelect.disabled = true;
        return;
      }

      try {
        const provinces = JSON.parse(provincesData);
        if (!Array.isArray(provinces) || provinces.length === 0) {
          provinceSelect.disabled = true;
          return;
        }

        provinceSelect.disabled = false;

        for (const [code, name] of provinces) {
          const option = document.createElement('option');
          option.value = name;
          option.textContent = name;

          if (provinceSelect.dataset.initialProvince && (code === provinceSelect.dataset.initialProvince || name === provinceSelect.dataset.initialProvince)) {
            option.selected = true;
          }

          provinceSelect.appendChild(option);
        }
      } catch (error) {
        provinceSelect.disabled = true;
      }
    };

    if (document.startViewTransition) {
      countrySelect.addEventListener('change', (event) => {
        event.preventDefault();
        document.startViewTransition(() => {
          updateProvinces();
        });
      });
    } else {
      countrySelect.addEventListener('change', updateProvinces);
    }

    updateProvinces();
  })();

  } catch(e) { console.error(e); }
})();
})();
